import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { PrismicLink as PrismicLink$1 } from "./react-server/PrismicLink.js";
import { usePrismicContext } from "./usePrismicContext.js";
const PrismicLink = React.forwardRef(function PrismicLink2(props, ref) {
  const context = usePrismicContext();
  return /* @__PURE__ */ jsx(PrismicLink$1, { ref, linkResolver: context.linkResolver, internalComponent: context.internalLinkComponent, externalComponent: context.externalLinkComponent, ...props });
});
export {
  PrismicLink
};
//# sourceMappingURL=PrismicLink.js.map
